export const TOOLTIP_DELAY_MS = 150;
